import React, { useState, useEffect } from 'react';
import MESSAGES from './random-messages';
export const RandomLoadingMessage = () => {
    const [randomMessage, changeRandomMessage] = useState(MESSAGES[Math.floor(Math.random() * MESSAGES.length)]);
    useEffect(() => {
        const timer = setTimeout(() => {
            changeRandomMessage(MESSAGES[Math.floor(Math.random() * MESSAGES.length)]);
        }, 3000);
        return () => clearTimeout(timer);
    });
    return React.createElement("span", { className: "message" },
        randomMessage,
        "...");
};
//# sourceMappingURL=RandomLoadingMessage.js.map